import React from 'react';
import { Box } from '@drone-js/core';
import { OtpInput } from './OtpInput';

export type OtpInputBoxesProps = {
    setOtpValue: (value: string) => void;
    otpError?: boolean;
};

export const OtpInputBoxes: React.FC<OtpInputBoxesProps> = props => {
    const inputElements: React.RefObject<HTMLInputElement>[] = [
        React.useRef<HTMLInputElement>(null),
        React.useRef<HTMLInputElement>(null),
        React.useRef<HTMLInputElement>(null),
        React.useRef<HTMLInputElement>(null),
        React.useRef<HTMLInputElement>(null),
        React.useRef<HTMLInputElement>(null),
    ];

    const otpStates: [string, React.Dispatch<React.SetStateAction<string>>][] = inputElements.map(i =>
        React.useState('')
    );

    React.useEffect(() => {
        const current = otpStates.map(eachState => {
            return eachState[0];
        });

        if (current.includes('')) {
            props.setOtpValue(''); // clear
            return;
        }

        props.setOtpValue(current.join(''));
    }, [otpStates]);

    const setOtpAndMoveNext = (value: string, boxId: number) => {
        if (value.length > 1) handleMultipleInput(value, boxId);
        else {
            otpStates[boxId][1](value);
            if (value !== '') {
                const currentBox = inputElements[boxId];
                const nextBox = inputElements[boxId + 1];
                nextBox?.current?.focus();
            }
        }
    };

    const focusPrevBox = (boxId: number) => {
        const prevBox = inputElements[boxId - 1];
        if (!!prevBox) {
            prevBox?.current?.focus();
        }
    };

    const handleMultipleInput = (code: string, boxId?: number) => {
        const digitRegex = /^\d+$/;
        if (code) {
            const startIndex = boxId ?? 0;
            if (digitRegex.test(code)) {
                code.split('').forEach((code, index) => {
                    const pasteIndex = index + startIndex;
                    otpStates[pasteIndex] && setOtpAndMoveNext(code, pasteIndex);
                });
            }
        }
    };

    return (
        <Box display="flex" alignContent="center" alignItems="center" justifyContent="space-between" mb="24" mt="16">
            {inputElements.map((e: React.RefObject<HTMLInputElement>, index) => (
                <OtpInput
                    key={index}
                    id={index}
                    value={otpStates[index][0]}
                    onChange={setOtpAndMoveNext}
                    onBackSpace={focusPrevBox}
                    inputRef={e}
                    error={false}
                />
            ))}
        </Box>
    );
};
